import { useCallback, useEffect, useState } from 'react';
import l from '../../../services/api/Landings';
import { buildSchemaFromLanding } from '../utils';

const EMPTY = { definition: null, schema: [], loading: true, error: '' };
const sidequestSchema = { defaultFormFields: ['FullName', 'Tel', 'Email', 'City'], customFormField: [] };
export function useCrmFormSchema({ boardId, isSidequest = false, shareToken = '' }) {
  const [state, setState] = useState(EMPTY);
  const [revision, setRevision] = useState(0);
  const applySchema = useCallback(definition => setState({ boardId, definition, schema: buildSchemaFromLanding(definition), loading: false, error: '' }), [boardId]);
  const reload = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    let active = true;
    setState({ ...EMPTY, boardId });
    if (!boardId) return () => { active = false; };
    if (isSidequest) { applySchema(sidequestSchema);return () => { active = false; }; }
    (async () => {
      try {
        const response = await l.getLandingById(boardId);
        if (!active) return;
        if (!response || response.status >= 400 || !response.data?.landing) throw new Error('Schema unavailable');
        applySchema(response.data.landing);
      } catch {
        if (active) setState({ ...EMPTY, boardId, loading: false, error: 'Could not load form fields. Please try again.' });
      }
    })();
    return () => { active = false; };
  }, [boardId, isSidequest, shareToken, applySchema, revision]);
  return { ...(state.boardId === boardId ? state : EMPTY), applySchema, reload };
}
